import React, { PureComponent } from 'react';
import { Container, Header, Title, Content, Text, Button, Icon, Left, Body, Right, List, ListItem, Spinner, InputGroup, Input, Item, View } from 'native-base';
import {truncateOnWord} from './globals';

export default class PhoneContact extends PureComponent {
	render() {
		const { item, selecting } = this.props;
		return (
			<ListItem
				icon
				style={{ backgroundColor: item.selected ? '#dddddd' : 'transparent' }}
				onPress={() => this.props.onPress(item)}
				onLongPress={() => this.props.onLongPress(item)}>
				{selecting && (
					<Left>
						<Icon name={item.selected ? 'checkbox' : 'square-outline'} />
					</Left>
				)}
				<Body>
					<Text>{truncateOnWord(item.name || item.firstName + ' ' + item.lastName, 28).replace("\n", "")}</Text>
					<Text note>{item.emails && item.emails[0] && item.emails[0].email}</Text>
				</Body>

				<Right>
					<Text note>{item.phoneNumbers && item.phoneNumbers[0] && item.phoneNumbers[0].number}</Text>
				</Right>
			</ListItem>
		);
	}
}
